"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeeksOfTheMonthEnum = void 0;
var WeeksOfTheMonthEnum;
(function (WeeksOfTheMonthEnum) {
    WeeksOfTheMonthEnum[WeeksOfTheMonthEnum["FIRST"] = 1] = "FIRST";
    WeeksOfTheMonthEnum[WeeksOfTheMonthEnum["SECOND"] = 2] = "SECOND";
    WeeksOfTheMonthEnum[WeeksOfTheMonthEnum["THIRD"] = 3] = "THIRD";
    WeeksOfTheMonthEnum[WeeksOfTheMonthEnum["FOURTH"] = 4] = "FOURTH";
})(WeeksOfTheMonthEnum || (exports.WeeksOfTheMonthEnum = WeeksOfTheMonthEnum = {}));
